import * as React from 'react';

interface Props {
  onCancel: () => void;
  onOk: () => void;
}

export default class extends React.Component<Props> {
  render() {
    return (
      <div className="content prompt">
        <h1>Make your animations richer</h1>
        <p>
          To create more interesting and unique animations, it is recommended to
          use multiple layers.
          <br />
          If needed, a layer can be split into two from its options menu.
        </p>
        <img
          style={{
            width: '368px',
            height: 'auto',
            border: '1px solid rgba(255,255,255, 0.3)',
            marginTop: '20px'
          }}
          alt="screenshot"
          src="/media/screenshot-split.png"
          draggable={false}
        />
        <div className="buttons">
          <button className="large secondary" onClick={this.props.onOk}>
            Try now
          </button>
          <button className="large primary" onClick={this.props.onCancel}>
            Got it
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/split-layer/Prompt.tsx